import pdfMake from 'pdfmake/build/pdfmake'
import type { TDocumentDefinitions } from 'pdfmake/interfaces'
import vfs from 'pdfmake/build/vfs_fonts.js'
import print from 'print-js'

window.pdfMake.vfs = vfs.pdfMake.vfs

export async function imprimirComprovanteDeCancelamentoDoPagamento(comprovante: string): Promise<void> {
	const comprovanteReplicado: string[] = new Array(2).fill(comprovante)
	const pdf: string = await gerarDocumentoParaImpressaoDoComprovante(comprovanteReplicado)
	return new Promise((resolve, reject) => {
		print({
			printable: pdf,
			type: 'pdf',
			base64: true,
			onError: reject,
			onLoadingEnd: resolve,
		})
	})
}

async function gerarDocumentoParaImpressaoDoComprovante(params: string[]): Promise<string> {
	const content: any[] = params.map((comprovante, index) => {
		if (index === 0) {
			comprovante = comprovante
				.replace(/NRO LOGICO:.*?\n/g, '')
				.replace(/LABEL:.*?\n/g, '')
				.replace(/AID:.*?\n/g, '')
				.replace(/ARQC:.*?\n/g, '');
		}

		return { text: comprovante, pageBreak: index < params.length - 1 ? 'after' : undefined };
	});

	const docDefinition: TDocumentDefinitions = {
		pageSize: {
			width: 1000,
			height: 1000,
		},
		pageOrientation: 'portrait',
		pageMargins: [3, 5, 5, 5],
		content: [
			{ text: content[0].text},
			{ text: '---------------------------------------------------------------------------------------------------------', margin: [0, 10, 0, 0 ] } ,
			{ text: content[1].text, margin: [0, 20, 0, 0 ] },
		],
	};

	return new Promise((resolve) =>
		pdfMake.createPdf(docDefinition).getBase64((result) => resolve(result)),
	);
}

export async function gerarComprovanteSitefBytes(comprovante: string[]): Promise<Uint8Array> {
	const base64 = await gerarDocumentoParaImpressaoDoComprovanteSitef(comprovante)
	const binario = atob(base64)
	const bytes = new Uint8Array(binario.length)
	for (let i = 0; i < binario.length; i++) bytes[i] = binario.charCodeAt(i)
	return bytes
}

export async function imprimirComprovanteSitef(comprovante: string[]): Promise<void> {
	const pdf: string = await gerarDocumentoParaImpressaoDoComprovanteSitef(comprovante)
	return new Promise((resolve, reject) => {
		print({
			printable: pdf,
			type: 'pdf',
			base64: true,
			onError: reject,
			onLoadingEnd: resolve,
		})
	})
}

function textoParaPNG(
	texto: string,
	{
		fontSize = 9,
		lineHeight = 11,
		padding = 6,
		bg = '#FFFFFF',
		scale = 2, 
	} = {}) {
	const linhas = texto.replace(/\r\n/g, '\n').split('\n');

	const c = document.createElement('canvas');
	const ctx = c.getContext('2d')!;

	const fontCSS = `${fontSize}px monospace`;
	ctx.font = fontCSS;

	const maxWidth = Math.max(
		1,
		...linhas.map((l) => Math.ceil(ctx.measureText(l || ' ').width)),
	);

	const w = padding * 2 + maxWidth;
	const h = padding * 2 + lineHeight * linhas.length;

	c.width = Math.max(1, Math.ceil(w * scale));
	c.height = Math.max(1, Math.ceil(h * scale));

	ctx.scale(scale, scale);
	ctx.font = fontCSS;
	ctx.textBaseline = 'top';

	ctx.fillStyle = bg;
	ctx.fillRect(0, 0, c.width / scale, c.height / scale);

	ctx.fillStyle = '#000000';
	linhas.forEach((l, i) => {
		ctx.fillText(l || ' ', padding, padding + i * lineHeight);
	});

	return c.toDataURL('image/png');
}

async function gerarDocumentoParaImpressaoDoComprovanteSitef(
	params: string[],
): Promise<string> {
	const [primeiro, segundo] = params;

	const img1 = textoParaPNG(primeiro, { fontSize: 9 });

	const conteudo: any[] = [{ image: img1, width: 230 }];

	if (segundo) {
		conteudo.push({
			text:
        '---------------------------------------------------------------------',
			margin: [0, 10, 0, 10],
		});
		conteudo.push({ image: textoParaPNG(segundo, { fontSize: 9 }), width: 230 });
	}

	const docDefinition: TDocumentDefinitions = {
		pageMargins: [10, 10, 10, 10],
		content: conteudo,
	};

	return new Promise((resolve) =>
		pdfMake.createPdf(docDefinition).getBase64((result) => resolve(result)),
	);
}